// extracted by mini-css-extract-plugin
export default {"heading":"ct-z","corrected":"dt-z","redirectVerbiageContainer":"et-z","redirectVerbiageText":"ft-z"};